<template>
  <div class="pdp__subheader" role="tablist">
    <div class="pdp__subheader-item" v-if="hasFeatures" data-id="section-features" @click="scrollToSection('#section-features')" @keyup.enter="scrollToSection('#section-features')" tabindex="0" role="tab">Features</div>
    <div class="pdp__subheader-item" v-if="hasIncludes" data-id="section-includes" @click="scrollToSection('#section-includes')" @keyup.enter="scrollToSection('#section-includes')" tabindex="0" role="tab">Includes</div>
    <div class="pdp__subheader-item" v-if="hasSpecs" data-id="section-specs" @click="scrollToSection('#section-specs')" @keyup.enter="scrollToSection('#section-specs')" tabindex="0" role="tab">Specs</div>
    <div class="pdp__subheader-item" v-if="hasManuals" data-id="section-manuals" @click="scrollToSection('#section-manuals')" @keyup.enter="scrollToSection('#section-manuals')" tabindex="0" role="tab">Additional Product Information</div>
    <div class="pdp__subheader-item" v-if="hasChildproducts" data-id="section-product-line" @click="scrollToSection('#section-product-line')" @keyup.enter="scrollToSection('#section-product-line')" tabindex="0" role="tab">Product line</div>
  </div>
</template>

<script>
export default {
  props: {
    product: Object
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    // Check sticky header
    const headerSection = document.getElementById("shopify-section-header").getElementsByTagName("section")
    if (headerSection && headerSection.length > 0) {
      const headerSettings = document.getElementById("shopify-section-header").getElementsByTagName("section")[0].getAttribute('data-section-settings')
      if (headerSettings) {
        this.headerSettings = JSON.parse(headerSettings)
      }
    } 
    const header = document.getElementById('shopify-section-product-pdp-subheader');
    if (this.headerSettings.useStickyHeader) {
      header.style.top = "107px"
    } else {
      header.style.top = "0px"
    }
  },
  computed: {
    customData() {
      const { description } = this.product
      if (description) {
        return JSON.parse(description)
      }
      return null
    },
    hasFeatures() {
      if (this.customData) {
        const { featuresandbenefits } = this.customData
        if (featuresandbenefits) {
          return featuresandbenefits.split("|").length > 0
        }
      }
      return false
    },
    hasIncludes() {
      if (this.customData) {
        const { contents } = this.customData
        if (contents) {
          return contents.split("|").length > 0
        }
      }
      return false
    },
    specs() {
      if (this.customData) {
        const { specs } = this.customData
        if (specs && specs.spec) {
          let filteredSpecs = [];
          for (let i = 0; i < specs.spec.length; i++) {
            if (specs.spec[i].name.includes('_Specs')) {
              filteredSpecs.push(specs.spec[i]);
            }
          }
          return filteredSpecs;
        }
      }
      return []
    },
    hasSpecs() {
      if (this.customData) {
        const { specs } = this.customData
        if (specs && specs.spec) {
          return this.specs.length > 0
        }
      }
      return false
    },
    hasManuals() {
      if (this.customData) {
        const { drawings } = this.customData
        return drawings != null
      }
      return false
    },
    hasChildproducts() {
      if (this.customData) {
        const { childproducts } = this.customData
        if (childproducts && childproducts.childproduct) {
          return childproducts.childproduct.length > 0
        }
      }

      return false
    }
  },
  methods: {
    handleScroll() {
      const header = document.getElementById('shopify-section-product-pdp-subheader');
      const navLinks = document.querySelectorAll('.pdp__subheader .pdp__subheader-item');
      const pdpBottom = document.getElementById('shopify-section-product-pdp-bottom')
      const menuHeight = document.getElementById('shopify-section-header').clientHeight;
      const pdpTop = document.getElementById('shopify-section-product-pdp-top')
      const productSetsId = document.getElementById('shopify-section-product-sets');
      let productSets = 0;
        if (productSetsId !== null && productSetsId !== 'undefined') {
            productSets = productSetsId.clientHeight;
        }
      if ( window.pageYOffset >  ((pdpTop.clientHeight + menuHeight + productSets) - 60)) {
        
        header.classList.add('sticky-submenu');
        pdpBottom.classList.add('sticky-bottom')
      } else {
        header.classList.remove('sticky-submenu');
        pdpBottom.classList.remove('sticky-bottom')
      }

      const fromTop = window.pageYOffset;
      navLinks.forEach((link) => {
        const section = document.querySelector(`#${link.dataset.id}`);
        if (section) {
          if ((section.offsetTop - menuHeight - 50) <= fromTop && (section.offsetTop - menuHeight - 50) + section.offsetHeight > fromTop) {
            link.classList.add('active');
          } else {
            link.classList.remove('active');
          }
        }
      });
    },
    scrollToSection(sectionId) {
      const location = document.querySelector(sectionId).offsetTop;
      const menuHeight = document.getElementById('shopify-section-header').clientHeight;

      if (this.headerSettings.useStickyHeader) {
        window.scrollTo({ top: location - menuHeight - 50, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: location - menuHeight, behavior: 'smooth' });
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('onscroll', this.handleScroll);
  },
  data() {
    return {
      headerSettings: null
    }
  }
};
</script>

<style lang="scss" scoped>
</style>